import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { fetchAdjRequestsReport_ac } from '../../actions/adjustment_requests_report.ac'
import { lookups_ac, setTitle_ac } from '../../actions/me.ac'
import FilterListing from '../FilterListing'
import { PaginationWithNums } from '../PaginationNew'
import BaseLandingTemplate from '../Reports/BaseLandingTemplate.Parent'
import Loader from '../Shared/Loader'
import ExpandableAdjRow from './ExpandableAdjRow'

const styles = theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing.unit * 0.5,
    overflowY: 'auto'
  },
  scrollArea: {
    height: '100%',
    overflowY: 'auto'
  },
  message: {
    fontSize: '1em',
    padding: '8px'
  },
  pagination: {
    padding: 8,
    backgroundColor: '#00000005',
    borderBottom: '1px solid #00000030'
  }
})

const PAGE_TITLE = 'Adjustment Requests Report'
const DEFAULT_FILTERS = {
  state: {
    kind: 'checkbox',
    lbl: 'State',
    options: [
      { lbl: 'Comment Added', code: 'comment_added', checked: false },
      {
        lbl: 'Amount and Code Incorrect',
        code: 'amount_and_code_incorrect',
        checked: false
      },
      { lbl: 'Amount Incorrect', code: 'amount_incorrect', checked: false },
      { lbl: 'Approved', code: 'approved', checked: false },
      { lbl: 'Code Incorrect', code: 'code_incorrect', checked: false },
      { lbl: 'Submitted', code: 'submitted', checked: false },
      { lbl: 'Info Required', code: 'info_required', checked: false }
    ]
  },
  start: {
    kind: 'dateTime',
    lbl: 'From',
    placeholder: 'MM-DD-YYYY hh::mm a',
    value: '',
    dirty: false,
    error: false
  },
  end: {
    kind: 'dateTime',
    lbl: 'To',
    placeholder: 'MM-DD-YYYY hh::mm a',
    value: '',
    dirty: false,
    error: false
  }
}

class AdjRequestsReportLanding extends BaseLandingTemplate {
  constructor() {
    super()

    this.state = {
      filters: { ...DEFAULT_FILTERS },
      filterSequence: ['state', 'start', 'end'],
      selectedPageNum: 0,
      allExpanded: false
    }

    this.fetch = this.fetch.bind(this)
  }

  checkSituation = () => {
    const {
      adjRequestsReport,
      me,
      lookups,
      lookups_ac,
      setTitle_ac
    } = this.props

    if (!me.user) return

    if (lookups.ink === null) {
      if (lookups.isFetching) return

      return lookups_ac()
    }

    if (me.title !== PAGE_TITLE) {
      setTitle_ac(PAGE_TITLE)
    }

    if (
      !adjRequestsReport.report &&
      !adjRequestsReport.error &&
      !adjRequestsReport.isFetchingReport
    ) {
      this.fetch()
    }
  }

  componentDidMount() {
    this.checkSituation()
  }

  componentDidUpdate() {
    this.checkSituation()
  }

  fetch(pageNum = 0) {
    const { filters } = this.state
    let params = {
      page: pageNum
    }

    let state = filters.state.options
      .filter(opt => opt.checked)
      .map(opt => opt.code)

    if (state.length > 0) {
      params.state = [...state]
    }

    if (filters.start.value) {
      params.start = moment(filters.start.value)
        .utc()
        .format()
    }

    if (filters.end.value) {
      params.end = moment(filters.end.value)
        .utc()
        .format()
    }

    this.props.fetchAdjRequestsReport_ac(params)
  }

  applyFilters = () => {
    this.setState({
      selectedPageNum: 0
    })

    return this.fetch()
  }

  handlePageChange = newPageNum => {
    let targetPage = parseInt(newPageNum, 10) - 1

    this.setState({
      selectedPageNum: targetPage
    })

    this.fetch(targetPage)
  }

  toggleAllExpandedState = () => {
    this.setState(state => ({
      allExpanded: !state.allExpanded
    }))
  }

  getPageStatement = pagination => {
    const { start, end, totalRecords, totalPagesAvailable } = pagination
    let pageEnd = totalRecords < end ? totalRecords : end

    return [
      `Displaying ${start + 1} - ${pageEnd} of ${totalRecords} Total `,
      ` Page ${this.state.selectedPageNum + 1} of ${totalPagesAvailable}`
    ].join('-')
  }

  render() {
    const { classes, adjRequestsReport, me } = this.props
    const { filters, filterSequence, allExpanded } = this.state
    const { report, isFetchingReport, error } = adjRequestsReport

    if (isFetchingReport) {
      return <Loader classes={{ message: classes.message }} />
    }

    let filterListing = (
      <FilterListing
        me={me}
        filters={filters}
        onFilterChange={this.onFilterChange}
        filterSequence={filterSequence}
        applyFilters={this.applyFilters}
        onFilterClearField={this.onFilterClearField}
      />
    )

    if (error) {
      return (
        <>
          {filterListing}
          <Typography color="error" className={classes.message}>
            Error fetching report
          </Typography>
        </>
      )
    }

    if (!report) {
      return (
        <>
          {filterListing}
          <div className={classes.message}>...</div>
        </>
      )
    }

    const { pagination: pg } = report
    let pageStatement = ''
    if (pg) {
      pageStatement = this.getPageStatement(pg)
    }

    let pageSelector = ''
    if (pg.totalPagesAvailable > 1) {
      pageSelector = (
        <PaginationWithNums
          currentPageNum={pg.currentPageNum}
          totalPagesAvailable={pg.totalPagesAvailable}
          onPageChange={this.handlePageChange}
        />
      )
    }

    return (
      <>
        {filterListing}
        <div className={classes.content}>
          <div className={classes.pagination}>
            <Grid container spacing={16} alignItems="flex-end">
              <Grid item xs={12} sm={6}>
                <Typography
                  inline
                  color="textSecondary"
                  onClick={this.toggleAllExpandedState}
                  style={{ cursor: 'pointer' }}>
                  <strong>
                    {allExpanded ? 'Collapse' : 'Expand'}
                    &ensp;All&ensp;[+/-]
                  </strong>
                </Typography>
                <Typography color="textSecondary">{pageStatement}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                {pageSelector}
              </Grid>
            </Grid>
          </div>

          <div className={classes.scrollArea}>
            <Table padding="dense">
              <TableHead>
                <TableRow>
                  <TableCell width="1%" />
                  <TableCell width="17%" style={{ padding: 8 }}>
                    Request
                  </TableCell>
                  <TableCell width="14%" style={{ padding: 8 }}>
                    User(s)
                  </TableCell>
                  <TableCell width="28%" style={{ padding: 8 }}>
                    Log(s)
                  </TableCell>
                  <TableCell width="40%" style={{ padding: 8 }}>
                    Reason group(s)
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {report.records &&
                  report.records.length > 0 &&
                  report.records.map((record, idx) => (
                    <ExpandableAdjRow
                      key={idx}
                      rowIdx={idx}
                      record={record}
                      isExpandedDefault={allExpanded}
                    />
                  ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = stateFromStore => ({
  me: stateFromStore.me,
  lookups: stateFromStore.lookups,
  adjRequestsReport: stateFromStore.adjRequestsReport
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      lookups_ac,
      setTitle_ac,
      fetchAdjRequestsReport_ac
    },
    dispatch
  )

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(AdjRequestsReportLanding))
)
